import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { SITE } from "@/data/site";

// Sticky bottom conversion bar for mobile only. Layout adds bottom padding on
// mobile so this never covers page content.
export default function MobileActionBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-[#23232d] bg-[#0A0A0C]/95 p-2.5 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
      data-testid="mobile-action-bar"
    >
      <a
        href={SITE.phonePrimary.tel}
        data-testid="sticky-call-btn"
        className="flex items-center justify-center gap-2 rounded-xl border border-[#2c2c37] bg-[#15151c] py-3 text-sm font-bold text-white active:scale-[0.98]"
      >
        <Phone className="h-4 w-4 text-amber-400" /> Call Now
      </a>
      <Link
        to="/request-a-quote"
        data-testid="sticky-quote-btn"
        className="flex items-center justify-center gap-2 rounded-xl bg-amber-400 py-3 text-sm font-bold uppercase tracking-wide text-[#0A0A0C] active:scale-[0.98]"
      >
        <FileText className="h-4 w-4" /> Request Quote
      </Link>
    </div>
  );
}
